export const loadScriptOnce = (
    src,
    {parent = document.body, async = true, defer = true, type} = {}
) => {
    if (!src) return null

    const normalizedSrc = new URL(src, document.baseURI).href
    const existingScript = Array.from(document.scripts).find(
        (script) => script.src === normalizedSrc
    )
    if (existingScript) return existingScript

    const script = document.createElement('script')
    script.src = src
    script.async = async
    script.defer = defer
    if (type) script.type = type
    script.addEventListener('error', () => script.remove(), {once: true})
    parent.appendChild(script)

    return script
}
